import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UnassignPartsOrdersMutationVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type UnassignPartsOrdersMutation = { __typename?: 'mutation_root', update_delivery_orders?: { __typename?: 'delivery_orders_mutation_response', affected_rows: number } | null };


export const UnassignPartsOrdersDocument = gql`
    mutation unassignPartsOrders($orderIds: [bigint!]!) {
  update_delivery_orders(
    where: {id: {_in: $orderIds}}
    _set: {run_id: null, stop_id: null, status: "pending"}
  ) {
    affected_rows
  }
}
    `;
export type UnassignPartsOrdersMutationFn = Apollo.MutationFunction<UnassignPartsOrdersMutation, UnassignPartsOrdersMutationVariables>;

/**
 * __useUnassignPartsOrdersMutation__
 *
 * To run a mutation, you first call `useUnassignPartsOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPartsOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPartsOrdersMutation, { data, loading, error }] = useUnassignPartsOrdersMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useUnassignPartsOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UnassignPartsOrdersMutation, UnassignPartsOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignPartsOrdersMutation, UnassignPartsOrdersMutationVariables>(UnassignPartsOrdersDocument, options);
      }
export type UnassignPartsOrdersMutationHookResult = ReturnType<typeof useUnassignPartsOrdersMutation>;
export type UnassignPartsOrdersMutationResult = Apollo.MutationResult<UnassignPartsOrdersMutation>;
export type UnassignPartsOrdersMutationOptions = Apollo.BaseMutationOptions<UnassignPartsOrdersMutation, UnassignPartsOrdersMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/unassignPartsOrders.mutation.gql}
 */
export async function unassignPartsOrders(
  variables: UnassignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UnassignPartsOrdersMutation['update_delivery_orders']>
export async function unassignPartsOrders(
  variables: UnassignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UnassignPartsOrdersMutation>
export async function unassignPartsOrders(
  variables: UnassignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UnassignPartsOrdersMutation['update_delivery_orders'] | UnassignPartsOrdersMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UnassignPartsOrdersMutation>(
    UnassignPartsOrdersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_orders
}